import { render, staticRenderFns } from "./UcLogin.vue?vue&type=template&id=434ab4a2&scoped=true&"
import script from "./UcLogin.vue?vue&type=script&lang=js&"
export * from "./UcLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434ab4a2",
  null
  
)

export default component.exports